import { deviceManagementTenantNavigation } from '../domain/navigation-tenant.util';

export default deviceManagementTenantNavigation;
